import GlobalState from "globalState";
import { createSelector } from "reselect";

export const dialogsSelector = (state: GlobalState) => state.dialogs;

export const isDialogOpen = (key: string): (state: GlobalState) => boolean => {
    return createSelector(dialogsSelector, (dialogs) =>
        dialogs.hasOwnProperty(key) && !!dialogs[key]);
};